import { AppMode, BetbyBonusBehavior, CatalogFilter, EndpointType, Theme } from '../types';
// SEO configuration for Turbo brand
const seoConfig = {
    companyName: 'Turbo Crypto Casino',
    routes: {
        '/': {
            title: 'Turbo Crypto Casino | Sportsbook, Live Casino & Instant Withdrawals',
            description: 'Play slots, live casino & bet on sports at Turbo Crypto Casino. Crypto casino with instant withdrawals, provably fair games & 24/7 support.'
        },
        '/casino': {
            title: 'Online Casino | Slots, Blackjack & Live Dealers | Turbo Crypto Casino',
            description: 'Play slots, blackjack, roulette & live dealers at Turbo Crypto Casino. Hundreds of games, fast crypto deposits & instant withdrawals available 24/7.'
        },
        '/sports': {
            title: 'Online Sportsbook | Crypto Sports Betting & Odds | Turbo Crypto Casino',
            description: 'Bet on sports at Turbo Crypto Casino. Competitive odds on football, basketball & more. Live betting, secure crypto wagering & fast payouts.'
        },
        '/about-us': {
            title: 'About Us | Learn More About Turbo Crypto Casino',
            description: 'Learn about Turbo Crypto Casino, a leading crypto casino & sportsbook. Committed to secure, fair & thrilling gambling with instant crypto withdrawals.'
        },
        '/affiliate': {
            title: 'Affiliate Program | Earn Crypto with Turbo Crypto Casino',
            description: 'Partner with Turbo Crypto Casino & earn commissions promoting our crypto casino. Competitive rates, real-time tracking & dedicated affiliate support.'
        },
        '/aml-policy': {
            title: 'AML Policy | Anti-Money Laundering at Turbo Crypto Casino',
            description: "Turbo Crypto Casino's AML policy ensures a secure, trustworthy environment. Read about our measures to prevent illicit activity on our platform."
        },
        '/bonus-terms': {
            title: 'Bonus Terms & Conditions | Turbo Crypto Casino Promotions',
            description: "Read the rules for Turbo Crypto Casino's bonuses & promotions. Learn how to claim, use & withdraw bonus winnings from our platform."
        },
        '/complaints-and-arbitration': {
            title: 'Complaints and Arbitration | Player Support at Turbo Crypto Casino',
            description: "Find Turbo Crypto Casino's complaint & dispute resolution process. We ensure fair treatment and resolve player issues quickly and transparently."
        },
        '/fairness': {
            title: 'Provably Fair Games | Ensure Fairness at Turbo Crypto Casino',
            description: 'Turbo Crypto Casino uses provably fair technology to guarantee every game result is verifiable, transparent & completely random.'
        },
        '/fairness/overview': {
            title: 'Provably Fair Gaming Overview | Turbo Crypto Casino',
            description: "Turbo Crypto Casino's provably fair system explained. Cryptographic principles guaranteeing game integrity & complete randomness on every result."
        },
        '/favorites': {
            title: 'Your Favorite Games | Quick Access | Turbo Crypto Casino',
            description: 'Access your saved casino games at Turbo Crypto Casino. Your personal list of top slots, table games & live dealers, always one click away.'
        },
        '/featurebuyin': {
            title: 'Feature Buy-In Slots | Skip to Bonus Rounds | Turbo Crypto Casino',
            description: "Skip straight to bonus rounds with Turbo Crypto Casino's feature buy-in slots. Instantly trigger bonus features for a chance at big wins."
        },
        '/gameshows': {
            title: 'Live Gameshows | Play Casino Gameshows at Turbo Crypto Casino',
            description: 'Play live casino gameshows at Turbo Crypto Casino. Enjoy Crazy Time, Monopoly Live & more, hosted by professional dealers in real time.'
        },
        '/kyc-policy': {
            title: 'KYC Policy | Know Your Customer at Turbo Crypto Casino',
            description: "Turbo Crypto Casino's KYC policy outlines our identity verification process. Learn how we protect players and maintain a secure gaming environment."
        },
        '/livecasino': {
            title: 'Live Casino | Blackjack, Roulette & Live Dealers | Turbo Crypto Casino',
            description: 'Play blackjack, roulette & live casino games at Turbo Crypto Casino. Real dealers, HD streaming & a wide selection of live tables available 24/7.'
        },
        '/newgames': {
            title: 'New Casino Games | Latest Slots & Live Games | Turbo Crypto Casino',
            description: 'Play the latest casino games at Turbo Crypto Casino. Regularly updated with new slots & table games from top providers. Be first to play.'
        },
        '/payment-policy': {
            title: 'Payment Policy | Crypto Deposits & Withdrawals | Turbo Crypto Casino',
            description: 'Turbo Crypto Casino accepts crypto deposits & withdrawals. Read our payment policy for transaction limits, accepted coins & processing times.'
        },
        '/populargames': {
            title: 'Popular Casino Games | Top Slots & Live Games | Turbo Crypto Casino',
            description: 'Play the most popular casino games at Turbo Crypto Casino. Top-rated slots & table games loved by our community, available with crypto.'
        },
        '/privacy-policy': {
            title: 'Privacy Policy | Data Protection at Turbo Crypto Casino',
            description: "Turbo Crypto Casino's privacy policy. Learn how we collect, use & protect your personal data on our crypto casino platform."
        },
        '/promotion-page': {
            title: 'Casino Promotions | Bonuses & Special Offers | Turbo Crypto Casino',
            description: "Browse Turbo Crypto Casino's latest promotions. Current bonuses, tournaments & special events – claim your offer and start playing."
        },
        '/providers': {
            title: 'Game Providers | Partnered Studios & Software | Turbo Crypto Casino',
            description: 'Explore all game providers at Turbo Crypto Casino. We partner with top studios to bring you a diverse, high-quality crypto casino library.'
        },
        '/referral': {
            title: 'Referral Program | Invite Friends & Earn Rewards | Turbo Crypto Casino',
            description: 'Refer friends to Turbo Crypto Casino & earn rewards when they sign up and play. Share your link and collect bonuses for every referral.'
        },
        '/responsible-gaming': {
            title: 'Responsible Gaming | Play Safely at Turbo Crypto Casino',
            description: 'Turbo Crypto Casino is committed to responsible gambling. Access tools & resources to manage your gaming habits and play safely.'
        },
        '/slots': {
            title: 'Online Slots | Wide Variety of Casino Slots | Turbo Crypto Casino',
            description: 'Spin a massive collection of slots at Turbo Crypto Casino. Classic fruit machines, video slots & progressives – all playable with crypto.'
        },
        '/terms-of-service': {
            title: 'Terms of Service | Turbo Crypto Casino',
            description: 'Review the terms & conditions governing your use of Turbo Crypto Casino. Understand your rights and responsibilities as a player.'
        },
        '/terms-sports': {
            title: 'Sports Betting Terms & Conditions | Turbo Crypto Casino',
            description: "Turbo Crypto Casino's sports betting terms & conditions. Rules for placing bets, winning payouts & sportsbook usage on our platform."
        },
        '/vip': {
            title: 'VIP Program | Exclusive Rewards & Benefits | Turbo Crypto Casino',
            description: "Turbo Crypto Casino's VIP program: exclusive rewards, personalised bonuses & priority support. Tailored perks for loyal players."
        },
        '/welcome-offer': {
            title: 'Welcome Bonus Offer | Sign Up & Get Your Bonus | Turbo Crypto Casino',
            description: "Claim Turbo Crypto Casino's welcome bonus on your first deposit. Learn how to get started and make the most of our sign-up offer."
        }
    },
    titlePatterns: {
        game: 'Play ${game} Online Casino Game by ${provider} | ${brand}',
        provider: '${provider} Online Casino Games | ${brand}',
        sport: '${sport} Sports Betting | ${brand}',
        default: 'Play Crypto Casino Games | ${brand}'
    },
    descriptionPatterns: {
        game: '${game} by ${provider}, play online with Crypto or free with demo play at Turbo.',
        provider: 'Play top online slots by ${provider} at Turbo. Discover popular games, enjoy free demo play, or spin with crypto for exciting real-money action.',
        sport: 'Stay updated on ${sport} with the latest scores, news, and expert insights. Get in-depth coverage of every match, player stats, and highlights all in one place.'
    }
};
// SEO configuration for Fomo brand
const themeSetting = {
    theme: Theme.Turboslots,
    rankConfig: { sublevelFormat: 'numeric' },
    betbyEnabled: true,
    betbyBonusBehavior: BetbyBonusBehavior.NoBonusMoney,
    betbyThemeName: 'default',
    brand: 'turboslot.com',
    brandTitle: 'TurboSlot',
    canonicalUrl: 'https://turboslot.com',
    cdnBase: 'https://d2ja1zdclgdcul.cloudfront.net',
    cdnTiles: 'https://dov8t6u8y3gtk.cloudfront.net',
    cdnBanners: 'https://images.fomo.io/',
    discordLink: '',
    fingerprintjs: undefined, //'RRJpTry7JPqVq4qwU8TR',
    fingerprintjsHost: undefined, //'fp.turboslot.com',
    googleAnalytics: '',
    googleClientId: undefined, //'1030216308308-9ceh2uirt0ltfdb0duunbmg83kp41s9a.apps.googleusercontent.com',
    googleTagManager: '',
    languageDefault: 'tr',
    languages: ['en', 'tr'],
    languagesTiles: ['en', 'tr'],
    languagesAutoAccept: ['en', 'tr'],
    intercomId: 'e6olp9gz',
    supportEmail: 'support@fomo.io',
    telegramLink: undefined, //'',
    xLink: undefined, //'https://x.com/',
    noIndex: true,
    gameSetLimit: 60,
    themePath: 'fomoio',
    verbiageLabel: 'fomoio',
    ui: {
        mobileMenu: {
            mobileMenuStyle: 'alternative4',
            showTurboBets: true,
            showJackpot: true,
            showRewardsAndPromo: false,
            showChat: false,
            itemOrder: ['menu', 'sports', 'turbo-bets', 'casino', 'jackpot']
        },
        accordion: {
            accordionStyle: 'alternative'
        },
        auth: {
            useSolidAccentOAuthButton: false,
            showWalletConnect: false,
            useTightModalBodyPadding: false,
            useOffsetModalCloseButton: false
        },
        background: {
            backgroundStyle: 'solid'
        },
        bannerSwiper: {
            bannerSwiperStyle: 'alternative'
        },
        cardSwiper: {
            cardSwiperStyle: 'alternative4',
            viewAllAsButton: false,
            showNavigationArrows: true,
            disableEdgeMask: false,
            useRemoteIcons: true
        },
        button: {
            buttonStyle: 'contrast',
            useUppercaseAsDefault: true,
            usebuttonBackgroundImage: false
        },
        betby: {
            betslipBottom: 20,
            customUI: true
        },
        betfeed: {
            betfeedStyle: 'default',
            usedVerbiage: 'live',
            rowDensity: 'compact'
        },
        cashier: {
            useAcceptDeclineBonusType: true,
            withdrawOnlyUsdt: true,
            withdrawOnlyUsdtMemeCoins: true,
            showConversionRateDeposit: true,
            showWiddrawalOnlyUSDT: false,
            showProgressBarBonusMoney: true,
            useBuyCryptoIFrame: false,
            buyCryptoMaxAmount: 5000,
            buyCryptoMinAmount: 15,
            showQrCodeBuyCrypto: false,
            useSearchInputOnCryptoDropdown: false,
            showImageOnDepositBonusOffers: true,
            depositBonusWageringContributions: [
                { category: 'slots', percentage: 100 },
                { category: 'originals', percentage: 5 },
                { category: 'live_casino', percentage: 0 },
                { category: 'table_games', percentage: 0 }
            ],
            showWithdrawalWarningIfNoFunds: true,
            showWithdrawalPlayRequirementImmediately: true,
            cashierStyle: 'momentum',
            useCashierHomeScreen: true,
            useSidetabs: false,
            buyCryptoEnabled: false,
            useCashierV4: false,
            useCompactDepositAddressOptionLayout: false,
            useUsdtForDepositConversionRateSendInput: false,
            extendCashierVerbiageKeysWithBrandLabel: true,
            useConfigBaseCurrency: true
        },
        casinoLobby: {
            casinoLobbyStyle: 'momentum',
            showLiveWins: true
        },
        chat: {
            chatStyle: 'alternative4'
        },
        checkbox: {
            useAlternativeTick: false,
            checkboxStyle: 'alternative4'
        },
        dropdown: {
            dropdownStyle: 'alternative4',
            useDropdownBackgroundImage: false,
            applyBackgroundBlur: true
        },
        emailVerify: {
            emailVerifyStyle: 'alternative4'
        },
        footer: {
            footerStyle: 'alternative4',
            useEmbeddedShellDecor: false,
            useLegalsMarkdownContent: true
        },
        games: {
            showRacesLeaderboard: false,
            showNavigationOnMobile: false,
            showLikeButton: true,
            showLogoWhenPlayingDesktop: false,
            showGameInfoModalOnGamePathMobile: false,
            applyPedestalIllustrationHueShift: true,
            useCompactRacesLeaderboardInfoBackdrop: true,
            showRacesLeaderboardPerimeterIllustrations: false
        },
        header: {
            headerStyle: 'alternative4',
            buttonLoginVariant: 'secondary',
            useTightRewardsToggleHorizontalPadding: false
        },
        helpdesk: {
            useDynamicBonusTerms: true
        },
        home: {
            homeStyle: 'momentum',
            showBuyCryptoBanner: false,
            showLiveWins: true,
            cryptoBannerStyle: 'alternative',
            buyCryptoBannerArtStyle: 'minimal',
            showAdventCalendarPage: false
        },
        icons: {
            vipHeaderGlyphDarkFill: false,
            statusIconsUseWarmPalette: false,
            expandSectionToggleUsesMintAccent: false,
            navIconPickerAllowRemoteAssets: true,
            navIconPickerUseBundledIconFactories: false
        },
        infoCard: {
            infoCardStyle: 'solid-dark',
            hideBackgroundImage: true
        },
        input: {
            inputStyle: 'alternative2',
            transparentBackground: true
        },
        layout: {
            layoutStyle: 'alternative4',
            isContrastTextColor: true,
            useCompactVerticalPagePadding: true,
            useReducedMarginsInHomePage: false,
            useCurrentColorSidebar: true,
            useReferralIconAnimated: false,
            useNewIcons: false,
            useRemoteIcons: true,
            showCryptoPriceDropdown: false,
            showUpdownGameDropdown: false,
            useReferralBannerOnlyImageCustom: true,
            usePromoItemContentCustom: true,
            useCentralButtonOnMobileMenu: false,
            sectionIconSize: 24,
            useExpandedRankPresentation: false,
            useAlternateMobileSidebarBackdrop: false,
            embedWebSiteOrganizationJsonLd: false
        },
        liveWins: {
            liveWinsStyle: 'alternative',
            usedVerbiage: 'live_wins',
            useSpecialWinCards: false
        },
        loading: {
            useLottie: false,
            publicInitPageLoadDisplayFor: 3000,
            playerInitPageLoadDisplayFor: 3000,
            useCustomLoading: true
        },
        maintenance: {
            maintenanceStyle: 'default',
            contentSource: 'hardcoded'
        },
        geoblock: {
            contentSource: 'hardcoded'
        },
        modal: {
            modalStyle: 'flat',
            applyBackgroundBlur: true,
            hideBanners: true
        },
        walletDropdown: {
            applyBackgroundBlur: true,
            showBalancePreferenceToggles: true
        },
        notifications: {
            notificationsStyle: 'alternative4',
            useBorderedPlayerNotificationsIcon: true,
            useGradientPublicNotificationsIcon: true,
            useExtendedDepositNotificationTitles: false
        },
        toasts: {
            toastsStyle: 'default'
        },
        profileModal: {
            profileModalStyle: 'alternative4',
            showFavouriteToken: false,
            useStarsBackgroundOnFavouriteToken: false,
            useTokenArtBackgroundOnDesktop: true,
            useCompactFavouriteTokenMobileCard: true
        },
        promotions: {
            showExpiredPromotions: false,
            useAspectRatioBoxDetailCustom: true,
            limitedCashbackExpired: new Date('2027-01-01T00:00:00Z').getTime(),
            promotionsStyle: 'alternative'
        },
        provider: {
            providerStyle: 'alternative4',
            useSolidPrimaryGameCountBadge: true
        },
        referral: {
            referralDashboardBannerType: 'onlyImage',
            faqTitleStyle: 'badge',
            faqVisibilityPreset: 'all',
            accordionGlassStyle: false,
            rulesCardsStyle: 'illustrated',
            rulesFootnoteMuted: false,
            highlightStepTitles: false,
            rankProgressPalette: 'cool',
            usePrefixedVerbiageKeys: true,
            shareModalStyle: 'basic',
            shareMessageVariant: 'campaign',
            shareBannerStyle: 'classic',
            referralDashboardBannerStyle: 'classic'
        },
        affiliates: {
            enabled: false,
            usePrefixedVerbiageKeys: true
        },
        rewardsDropdown: {
            rewardsDropdownStyle: 'alternative',
            useTransparentBackground: true,
            useComfortableRewardsTimerLabels: false,
            showSeasonalRewardsCampaignTabs: false
        },
        seoText: {
            style: 'momentum'
        },
        settings: {
            settingsStyle: 'alternative'
        },
        sidebar: {
            sidebarStyle: 'alternative4',
            showJackpotMEGA: true,
            showLuckyDip: false,
            showBanner: false,
            dropDownToggleTransparent: true,
            useRemoteIcons: true
        },
        table: {
            tableStyle: 'alternative4'
        },
        tabs: {
            tabsStyle: 'alternative4',
            useCompactTabStripRadius: true,
            tabButtonsDefaultVariant: 'accent'
        },
        text: {
            successTextUsesWarmTone: false
        },
        toggle: {
            toggleStyle: 'alternative'
        },
        tooltip: {
            tooltipStyle: 'alternative'
        },
        topSection: {
            casinoTopSectionStyle: 'alternative'
        },
        transactions: {
            transactionsStyle: 'alternative',
            useSegmentedTabs: false,
            useElevatedRows: false,
            showEmptyStateIllustration: false
        },
        vip: {
            vipDashboardStyle: 'alternative',
            vipAboutStyle: 'alternative',
            scaleRewardsImages: false,
            useMarkdownFaqs: false,
            heroCardOpacity: 0.9,
            rewardsTableLayout: 'detailed',
            rewardsProgressPalette: 'cool',
            includeWageringRequirementRow: false,
            reorderPrimaryBenefitCards: false,
            testimonialsHeaderStyle: 'badge',
            useCompactTestimonialsCardHeight: false,
            faqListLength: 'full',
            usePrefixedVerbiageKeys: true,
            assetSet: 'elevated',
            negativeBadgeTone: 'coral',
            showRankPrefixBeforeDisplayName: false,
            useAccentPendingTotalsBadge: true,
            useBorderOnMiniVipCalendarCard: true,
            useCompactClubOverviewSectionHeights: true,
            useCompactRoyaltyBannerTypography: true,
            useExpandedRoyaltyBannerSectionSpacing: true,
            useGradientVipCalendarDateHeader: true,
            useTallerRoyaltyBannerOnNarrowScreens: true,
            showRoyaltyBannerInDashboard: false,
            calendarSummaryLabel: 'claimed',
            includeRaceInRakebackBreakdown: false,
            showVipRewardTooltips: false,
            monthlyRewardsTooltipStyle: 'compact',
            useClassicVipCalendarCardChrome: false,
            rakeboostProgressTone: 'accent'
        },
        progressBar: {
            showProgressIcon: false
        },
        profileDropdown: {
            showSupport: false,
            profileDropdownStyle: 'default'
        }
    },
    seo: seoConfig
};
const themeSettings = [
    {
        ...themeSetting,
        brand: 'turbo-gamma.previewenv.net',
        languages: ['en', 'tr'],
        noIndex: true
    }
];
export const getThemeSetting = (domain, fullDomain) => {
    const setting = themeSettings.find((s) => fullDomain.includes(s.brand));
    if (setting)
        return setting;
    return themeSetting;
};
export const endpointSettings = [
    {
        name: 'turbo',
        theme: Theme.Turboslots,
        base: 'monopoly-turbo.prod.infinitro.dev',
        baseCurrency: 'TRY',
        baseCurrencySymbol: '₺',
        baseCurrencyDigits: 2,
        realm: 'prod-turbo',
        catalogFilter: CatalogFilter.ReleaseGames,
        endpointType: EndpointType.Production,
        reownProjectId: '441421829a4cc3f2eaf2cccd9a34afff'
    }
];
export const endpointSetting = (appMode, // eslint-disable-line @typescript-eslint/no-unused-vars
domain, // eslint-disable-line @typescript-eslint/no-unused-vars
fullDomain // eslint-disable-line @typescript-eslint/no-unused-vars
) => {
    return endpointSettings[0];
};
